import React from 'react';
import { View, Badge, Link } from '@adobe/react-spectrum';
import { PictureAsPdfRounded } from '@mui/icons-material';
import { Paper, Table, Checkbox, TableBody, TableHead, TableRow } from '@mui/material';
import { isPastMonthYear } from '../../../../util';
import { studentPaymentListHeader, FeesStatus } from '../constant';
import { StudentPaymentData } from '../../types';
import { CustomTableContainer as TableContainer, CustomTableCell as TableCell } from '../../../../CommonComponent/CustomTableItems';

const FeesRecords: React.FC<{ localStudentData: StudentPaymentData; setLocalStudentData: React.Dispatch<React.SetStateAction<StudentPaymentData>> }> = ({
  localStudentData,
  setLocalStudentData,
}) => {
  const handleCheckBox = (idx: number) => {
    const updatedValue = localStudentData.feesDetails.map((item, index) => {
      if (index === idx) {
        return {
          ...item,
          feesStatus: item.feesStatus === FeesStatus.INPROCESS ? FeesStatus.UNPAID : FeesStatus.INPROCESS,
        };
      }
      return item;
    });
    setLocalStudentData({
      ...localStudentData,
      feesDetails: updatedValue,
    });
  };
  return (
    <View height="40vh" overflow="auto" marginTop="size-200">
      <TableContainer
        component={Paper}
        sx={{
          width: '100%',
          overflowX: 'auto',
        }}
      >
        <Table stickyHeader sx={{ minWidth: studentPaymentListHeader.length * 150 }}>
          <TableHead>
            <TableRow>
              {studentPaymentListHeader.map((item, idx) => (
                <TableCell key={idx} sx={{ backgroundColor: '#fff', fontWeight: 'bold' }} align="center">
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {localStudentData.feesDetails.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell align="center">{`${row.month} ${row.year}`}</TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={row.feesStatus === FeesStatus.PAID || row.feesStatus === FeesStatus.INPROCESS}
                    disabled={row.feesStatus === FeesStatus.PAID}
                    onChange={() => handleCheckBox(idx)}
                  />
                  {isPastMonthYear(row.month, row.year) && row.feesStatus !== FeesStatus.PAID && <Badge variant="negative">Late Fees Applicable</Badge>}
                </TableCell>
                <TableCell align="center">
                  {row.feesReciept && row.feesReciept.length > 0
                    ? row.feesReciept.map((link, i) => (
                        <Link key={i} href={link} target="_blank" isQuiet>
                          <PictureAsPdfRounded />
                        </Link>
                      ))
                    : 'N/A'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </View>
  );
};

export default FeesRecords;
